module.exports = __webpack_public_path__ + "img/blocked-user-aktiv.caca8322.svg";